import {useUserDevice} from "@pg-mono/user-device";

import {useApplicationMultiLead} from "../../hooks/multi_lead/use_application_multi_lead";
import {IApplicationMultiLeadProps} from "../../types/multi_lead/IApplicationMultiLeadProps";
import {ApplicationMultiLeadSimpleRecommendationsModal} from "./ApplicationMultiLeadSimpleRecommendationsModal";
import {ApplicationMultiLeadWrapper} from "./ApplicationMultiLeadWrapper";

export const ApplicationMultiLead = (props: IApplicationMultiLeadProps) => {
    const {
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        originalApplicationFormValues,
        originalApplicationResponse,
        recommendationType,
        recommendationsWithPriceFilter,
        showOriginalOffer,
        sourceSection,
        customSourceSection,
        customGtmTracking,
        disableDefaultSelection
    } = props;

    const {isMobile} = useUserDevice();
    const {onSuccessfulSubmit, onCloseClick} = useApplicationMultiLead({
        recommendationType,
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        customGtmTracking
    });

    return (
        <ApplicationMultiLeadWrapper isScrollable={Boolean(isMobile)}>
            <ApplicationMultiLeadSimpleRecommendationsModal
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                showOriginalOffer={showOriginalOffer}
                sourceSection={sourceSection}
                onModalClose={onCloseClick}
                onSuccessfulSubmit={onSuccessfulSubmit}
                recommendationType={recommendationType}
                customSourceSection={customSourceSection}
                originalApplicationResponse={originalApplicationResponse}
                customGtmTracking={customGtmTracking}
                disableDefaultSelection={disableDefaultSelection}
            />
        </ApplicationMultiLeadWrapper>
    );
};
import {useUserDevice} from "@pg-mono/user-device";

import {useApplicationMultiLead} from "../../hooks/multi_lead/use_application_multi_lead";
import {IApplicationMultiLeadProps} from "../../types/multi_lead/IApplicationMultiLeadProps";
import {ApplicationMultiLeadSimpleRecommendationsModal} from "./ApplicationMultiLeadSimpleRecommendationsModal";
import {ApplicationMultiLeadWrapper} from "./ApplicationMultiLeadWrapper";

export const ApplicationMultiLead = (props: IApplicationMultiLeadProps) => {
    const {
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        originalApplicationFormValues,
        originalApplicationResponse,
        recommendationType,
        recommendationsWithPriceFilter,
        showOriginalOffer,
        sourceSection,
        customSourceSection,
        customGtmTracking,
        disableDefaultSelection
    } = props;

    const {isMobile} = useUserDevice();
    const {onSuccessfulSubmit, onCloseClick} = useApplicationMultiLead({
        recommendationType,
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        customGtmTracking
    });

    return (
        <ApplicationMultiLeadWrapper isScrollable={Boolean(isMobile)}>
            <ApplicationMultiLeadSimpleRecommendationsModal
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                showOriginalOffer={showOriginalOffer}
                sourceSection={sourceSection}
                onModalClose={onCloseClick}
                onSuccessfulSubmit={onSuccessfulSubmit}
                recommendationType={recommendationType}
                customSourceSection={customSourceSection}
                originalApplicationResponse={originalApplicationResponse}
                customGtmTracking={customGtmTracking}
                disableDefaultSelection={disableDefaultSelection}
            />
        </ApplicationMultiLeadWrapper>
    );
};
